import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "買取承認待ち", enum: "PURCHASE", name: "purchase" },
  { value: 2, text: "承認済み", enum: "APPROVED", name: "approved" },
]);
